/* eslint-disable import/prefer-default-export */
import axios from '../config/axios';

export function enviarMensaje(message, session_id) {
  return new Promise((resolve, reject) => {
    axios.post('/dialogflow_client/dialogflow', {
      message,
      session_id,
      canal: 'web',
      action: 'text',
    })
      .then((result) => {
        resolve(result);
      }).catch((err) => {
        reject(err);
      });
  });
}



// WEBPACK FOOTER //
// ./src/apiService/request/df_client.js